// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2Bf_t","form":"styles_form__1SD2A"};